import { Group, NumberInput, Text, TextInput } from '@mantine/core';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const AddressCard: React.FC = () => {
  const form = useEmployeeFormContext();

  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Adresa
      </Text>
      <TextInput
        required
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="ulice"
        label="Ulice"
        {...form.getInputProps('permAddress.street')}
      />
      <Group justify="space-between" grow align="start">
        <NumberInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="číslo popisné"
          label="Číslo popisné"
          {...form.getInputProps('permAddress.descNum')}
        />
        <NumberInput
          required
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="číslo orientační"
          label="Číslo orientační"
          {...form.getInputProps('permAddress.orientNum')}
        />
      </Group>
      <TextInput
        required
        variant="filled"
        radius="md"
        placeholder="město"
        label="Město"
        {...form.getInputProps('permAddress.city')}
      />
      <TextInput
        required
        variant="filled"
        radius="md"
        placeholder="PSČ"
        label="PSČ"
        {...form.getInputProps('permAddress.postCode')}
      />
    </div>
  );
};
